import { generateEntityCrudActionTypes } from 'syft-acp-util/store/action-types'

const csatAgenciesCrudActionTypes = generateEntityCrudActionTypes('watchlistCompliance')

export default { ...csatAgenciesCrudActionTypes }
